module.exports = __webpack_public_path__ + "static/media/close.7cb3f077.png";